import React, { useEffect, useState } from "react";
import axios from "axios";

const ConditionText = ({ text }) => {
  const [expanded, setExpanded] = useState(false);
  const lines = text?.split("\n") || [];
  const preview = lines.slice(0, 3).join("\n");
  const hasMore = lines.length > 3;

  return (
    <div style={{ fontSize: 11.5, color: "#5a6070", lineHeight: 1.65, whiteSpace: "pre-line" }}>
      {expanded ? text : preview}
      {hasMore && (
        <button
          onClick={() => setExpanded((e) => !e)}
          style={{ display: "block", marginTop: 4, background: "none", border: "none", color: "#1a9e78", fontSize: 11, cursor: "pointer", padding: 0 }}
        >
          {expanded ? "Show less ▲" : "Show more ▼"}
        </button>
      )}
    </div>
  );
};

// ─── Edit Modal ───────────────────────────────────────────────────────────────
const EditCardModal = ({ card, onClose, onSaved }) => {
  const [form, setForm] = useState({
    cardname: card.cardName || "",
    condition: card.condition || "",
    equipment: card.equipment || "",
    machine: card.machine || "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (field, value) =>
    setForm((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = async () => {
    if (!form.cardname.trim()) return setError("Card name is required.");
    try {
      setSaving(true);
      await axios.put(`https://api.hanoch.in/performance/action-cards/${card.id}/`, {
        cardname: form.cardname,
        condition: form.condition,
        equipment: form.equipment,
        machine: form.machine,
      });
      onSaved();
      onClose();
    } catch (err) {
      setError("Failed to save. Please try again.");
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  const overlay = {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.35)",
    display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
  };
  const modal = {
    background: "#fff", borderRadius: 12, padding: 28, width: 480,
    boxShadow: "0 8px 32px rgba(0,0,0,.15)", display: "flex", flexDirection: "column", gap: 16,
  };
  const label = { fontSize: 11.5, fontWeight: 500, color: "#5a6070", marginBottom: 4, display: "block" };
  const input = {
    width: "100%", boxSizing: "border-box", border: "0.5px solid #e2e4e8",
    borderRadius: 6, padding: "8px 10px", fontSize: 12, color: "#1a1e2e", outline: "none",
  };

  return (
    <div style={overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={modal}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: 14, fontWeight: 600, color: "#1a1e2e" }}>Edit Risk Trigger Card</span>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#8a909e" }}>×</button>
        </div>

        {error && (
          <div style={{ background: "#fff3f3", border: "0.5px solid #e24b4a", borderRadius: 6, padding: "8px 12px", fontSize: 12, color: "#e24b4a" }}>
            {error}
          </div>
        )}

        <div>
          <label style={label}>Machine</label>
          <input style={input} value={form.machine} onChange={(e) => handleChange("machine", e.target.value)} />
        </div>
        <div>
          <label style={label}>Card Name</label>
          <input style={input} value={form.cardname} onChange={(e) => handleChange("cardname", e.target.value)} />
        </div>
        <div>
          <label style={label}>Sub Equipment</label>
          <input style={input} value={form.equipment} onChange={(e) => handleChange("equipment", e.target.value)} />
        </div>
        <div>
          <label style={label}>Condition</label>
          <textarea
            style={{ ...input, minHeight: 100, resize: "vertical" }}
            value={form.condition}
            onChange={(e) => handleChange("condition", e.target.value)}
          />
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <button
            onClick={onClose}
            style={{ background: "#f5f6f8", border: "0.5px solid #e2e4e8", borderRadius: 6, padding: "7px 18px", fontSize: 12, cursor: "pointer", color: "#5a6070" }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={saving}
            style={{ background: "#1a9e78", color: "#fff", border: "none", borderRadius: 6, padding: "7px 18px", fontSize: 12, fontWeight: 500, cursor: saving ? "not-allowed" : "pointer", opacity: saving ? 0.7 : 1 }}
          >
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
};

// ─── Delete Confirm Modal ─────────────────────────────────────────────────────
const DeleteConfirmModal = ({ card, onClose, onDeleted }) => {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    try {
      setDeleting(true);
      await axios.delete(`https://api.hanoch.in/performance/action-cards/${card.id}/`);
      onDeleted();
      onClose();
    } catch (err) {
      setError("Failed to delete. Please try again.");
      console.error(err);
    } finally {
      setDeleting(false);
    }
  };

  const overlay = {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.35)",
    display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
  };

  return (
    <div style={overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={{ background: "#fff", borderRadius: 12, padding: 28, width: 400, boxShadow: "0 8px 32px rgba(0,0,0,.15)", display: "flex", flexDirection: "column", gap: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: 14, fontWeight: 600, color: "#1a1e2e" }}>Delete Trigger Card</span>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#8a909e" }}>×</button>
        </div>

        <p style={{ fontSize: 13, color: "#5a6070", margin: 0 }}>
          Are you sure you want to delete <strong>{card.cardName}</strong>? This action cannot be undone.
        </p>

        {error && (
          <div style={{ background: "#fff3f3", border: "0.5px solid #e24b4a", borderRadius: 6, padding: "8px 12px", fontSize: 12, color: "#e24b4a" }}>
            {error}
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <button
            onClick={onClose}
            style={{ background: "#f5f6f8", border: "0.5px solid #e2e4e8", borderRadius: 6, padding: "7px 18px", fontSize: 12, cursor: "pointer", color: "#5a6070" }}
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            disabled={deleting}
            style={{ background: "#e24b4a", color: "#fff", border: "none", borderRadius: 6, padding: "7px 18px", fontSize: 12, fontWeight: 500, cursor: deleting ? "not-allowed" : "pointer", opacity: deleting ? 0.7 : 1 }}
          >
            {deleting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

// ─── Kebab Menu ───────────────────────────────────────────────────────────────
const KebabMenu = ({ card, onEdit, onDelete }) => {
  const [open, setOpen] = useState(false);

  const actions = [
    { label: "Edit", color: "#1a1e2e", handler: onEdit },
    { label: "Delete", color: "#e24b4a", handler: onDelete },
  ];

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={() => setOpen((o) => !o)}
        style={{ background: "none", border: "none", cursor: "pointer", padding: "4px 6px", borderRadius: 4, color: "#8a909e", fontSize: 18 }}
      >
        ⋮
      </button>

      {open && (
        <>
          {/* backdrop to close on outside click */}
          <div style={{ position: "fixed", inset: 0, zIndex: 9 }} onClick={() => setOpen(false)} />
          <div style={{ position: "absolute", right: 0, top: "100%", background: "#fff", border: "0.5px solid #e2e4e8", borderRadius: 8, zIndex: 10, boxShadow: "0 4px 12px rgba(0,0,0,.08)", minWidth: 140 }}>
            {actions.map(({ label, color, handler }) => (
              <div
                key={label}
                onClick={() => { setOpen(false); handler(); }}
                style={{ padding: "9px 14px", fontSize: 12, color, cursor: "pointer" }}
              >
                {label}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

// ─── Main Table ───────────────────────────────────────────────────────────────
const RiskTriggerTable = ({ search = "", refreshKey, selectedMachine }) => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editCard, setEditCard] = useState(null);     // card object to edit
  const [deleteCard, setDeleteCard] = useState(null); // card object to delete

  useEffect(() => {
    fetchCards();
  }, [refreshKey, selectedMachine]);

  const fetchCards = async () => {
    try {
      setLoading(true);
      const url = selectedMachine
        ? `https://api.hanoch.in/performance/action-cards/?machine=${selectedMachine}`
        : `https://api.hanoch.in/performance/action-cards/`;
      const res = await axios.get(url);
      setCards(res.map((item) => ({
        id: item.id,
        machine: item.machine,
        cardName: item.cardname,
        condition: item.condition,
        equipment: item.equipment,
      })));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filtered = cards.filter(
    (c) =>
      !search ||
      c.cardName?.toLowerCase().includes(search.toLowerCase()) ||
      c.machine?.toLowerCase().includes(search.toLowerCase()) ||
      c.equipment?.toLowerCase().includes(search.toLowerCase())
  );

  const COL = { vessel: "22%", cardName: "22%", condition: "42%", equipment: "10%", action: "4%" };

  return (
    <>
      {editCard && (
        <EditCardModal
          card={editCard}
          onClose={() => setEditCard(null)}
          onSaved={fetchCards}          // re-fetch after save
        />
      )}

      {deleteCard && (
        <DeleteConfirmModal
          card={deleteCard}
          onClose={() => setDeleteCard(null)}
          onDeleted={fetchCards}        // re-fetch after delete
        />
      )}

      <div style={{ background: "#fff", border: "0.5px solid #e2e4e8", borderRadius: 10, overflow: "hidden" }}>
        {/* Header */}
        <div style={{ display: "grid", gridTemplateColumns: `${COL.vessel} ${COL.cardName} ${COL.condition} ${COL.equipment} ${COL.action}`, padding: "10px 16px", borderBottom: "0.5px solid #e2e4e8", background: "#f5f6f8" }}>
          {["Machine", "Card Name", "Condition", "Sub Equipment", ""].map((h, i) => (
            <div key={i} style={{ fontSize: 12, fontWeight: 500, color: "#8a909e" }}>{h}</div>
          ))}
        </div>

        {/* Body */}
        {loading ? (
          <div style={{ padding: 30, textAlign: "center" }}>Loading...</div>
        ) : filtered.length === 0 ? (
          <div style={{ padding: "40px 16px", textAlign: "center", color: "#aab0be" }}>No trigger cards found</div>
        ) : (
          filtered.map((card, idx) => (
            <div
              key={card.id}
              style={{ display: "grid", gridTemplateColumns: `${COL.vessel} ${COL.cardName} ${COL.condition} ${COL.equipment} ${COL.action}`, padding: "14px 16px", borderBottom: idx < filtered.length - 1 ? "0.5px solid #e2e4e8" : "none" }}
            >
              <div style={{ fontSize: 12, fontWeight: 500 }}>{card.machine}</div>
              <div style={{ fontSize: 12 }}>{card.cardName}</div>
              <div><ConditionText text={card.condition} /></div>
              <div style={{ fontSize: 11 }}>{card.equipment}</div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <KebabMenu
                  card={card}
                  onEdit={() => setEditCard(card)}
                  onDelete={() => setDeleteCard(card)}
                />
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default RiskTriggerTable;